import React, { useState, useRef } from "react";
import './Companies.scss';
import { Helmet } from "react-helmet";
import { useEffect } from "react";
import NavigatorPath from "../../Tools/NavigatorPath/NavigatorPath"
import { useLocation } from "react-router-dom";
import Faq from "react-faq-component";

// OpenAI Ads conversion event IDs per company × event type.
// Only fires when ?spg=o is in the URL (i.e. visitor came from an OpenAI Ads
// campaign). Add new event types here as we set them up in the dashboard.
const OPENAI_EVENTS = {
    "BHO Chimney Sweep": {
        web_click:  "bho_chimney_sweep_web_click",
        phone_call: "bho_chimney_sweep_phone_call",
    },
    "Master Air Duct": {
        web_click:  "master_air_duct_web_click",
        phone_call: "master_air_duct_phone_call",
    },
    "Rocket Air Care": {
        web_click:  "rocket_air_care_web_click",
        phone_call: "rocket_air_care_phone_call",
    },
    "Smith and Sons Chimney": {
        web_click:  "smith_and_sons_chimney_web_click",
        phone_call: "smith_and_sons_chimney_phone_call",
    },
};

function fireOpenAIEvent(companyName, eventType) {
    if (typeof window === "undefined") return;
    const params = new URLSearchParams(window.location.search);
    if (params.get("spg") !== "o") return;

    const eventName = OPENAI_EVENTS[companyName] && OPENAI_EVENTS[companyName][eventType];
    if (!eventName) return;
    if (typeof window.oaiq !== "function") return;

    const dedupeId = `${eventName}-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
    try {
        window.oaiq("measure", "custom", { type: "custom" }, {
            custom_event_name: eventName,
            event_id: dedupeId,
        });
    } catch (e) {
        // never block navigation on pixel errors
    }
}

export default function Companies({ Companies, CitiesData: CitiesDataProp, CategoryInfo, ShowAllCompanies, setShowAllCompanies }) {

    const url = new URL(window.location.href);

    // OpenAI ad URLs (spg=o) carry no geo `cd` param, so CitiesData is empty.
    // Derive City/Full from the last path segment, e.g.
    // /pros/Dryer-vent/Los-Angeles/Los-Angeles,CA -> { City: "Los Angeles", Full: "Los Angeles, CA" }
    let CitiesData = CitiesDataProp;
    if (url.searchParams.get('spg') === 'o') {
        const pathSegs = url.pathname.split('/').filter(Boolean);
        const lastSeg = pathSegs.length ? decodeURIComponent(pathSegs[pathSegs.length - 1]) : '';
        if (lastSeg.includes(',')) {
            const Full = lastSeg.split(',').map(p => p.trim().replace(/-/g, ' ')).join(', ');
            CitiesData = { ...(CitiesDataProp || {}), City: Full.split(',')[0].trim(), Full };
        }
    }

    const [DateServiceType, setDateServiceType] = useState();
    const [PathLocations, setPathLocations] = useState();
    if (CitiesData && CitiesData.Full) {
        // 
        const newPath = `/pros/${url.href.split('/')[4]}/${url.searchParams.get('area')}/${CitiesData.Full.split(',').map(part => part.trim().replace(/\s+/g, '-')).join(',')}`;
        const searchParams = window.location.search;
        const newUrl = `${window.location.origin}${newPath}${searchParams}`;
        // 
        if (newUrl) {
            window.history.replaceState(null, '', newUrl);
        }
    }
    const [showMore, setShowMore] = useState(false);
    const [showMoreMobile, setShowMoreMobile] = useState(false);
    const [showMenuMobile, setShowMenuMobile] = useState(false);
    const [scrollButton, setScrollButton] = useState(false);
    const [scrollButtonFindPro, setScrollButtonFindPro] = useState(false);
    const [response, setResponse] = useState({});

    const location = useLocation()
    const serviceParam = location.pathname.split('/')[2] || '';

    const handleScroll = () => {
        const position = window.pageYOffset;
        if (position > 250) {
            setScrollButton(true)
        } else if (position < 250) {
            setScrollButton(false)
        }

        if (position > 2250) {
            setScrollButtonFindPro(true)
        } else if (position < 2250) {
            setScrollButtonFindPro(false)
        }
    };
    const containerRefReviews = useRef(null);
    const scrollRightReviews = () => {
        if (containerRefReviews.current && window.screen.width > 800) {
            containerRefReviews.current.scrollLeft += 330;
        } else {
            containerRefReviews.current.scrollLeft += 290;
        }
    };
    const containerRefscrollRightOffer = useRef(null);
    const scrollRightOffer = () => {
        if (containerRefscrollRightOffer.current && window.screen.width > 800) {
            containerRefscrollRightOffer.current.scrollLeft += 280;
        } else {
            containerRefscrollRightOffer.current.scrollLeft += 270;
        }
    };
    const containerRefscrollRightKeyWords = useRef(null);
    const scrollRightKeyWords = () => {
        if (containerRefscrollRightKeyWords.current && window.screen.width > 800) {
            containerRefscrollRightKeyWords.current.scrollLeft += 320;
        } else {
            containerRefscrollRightKeyWords.current.scrollLeft += 320;
        }
    };

    // Set DateServiceType based on serviceParam
    useEffect(() => {
        if (CategoryInfo && CategoryInfo.length > 0 && serviceParam) {
            const found = CategoryInfo.find(a => a.UrlCategory.toLowerCase() === serviceParam.toLowerCase());
            if (found) setDateServiceType(found);
        }
    }, [CategoryInfo, serviceParam]);

    // Add scroll event listener only and AI Response
    useEffect(() => {
        (async () => {
            try {
                const aiKd = url.searchParams.get('kd');
                const aiService = serviceParam ? serviceParam.replace(/-/g, ' ') : '';
                const aiTopic = aiKd && aiKd !== 'null' ? aiKd : (aiService || (DateServiceType ? DateServiceType.Category : 'home services'));
                const searchKeyword = `I need from you 1 result 45 words about our 3 top ${DateServiceType ? DateServiceType.Category : aiService} contractors and how those 3 top companies can help our clients with "${aiTopic}", give me that as json file: title 6 words (include in the title words from the service, do not include the words "null" or "handyby") and body`
                const resChat = await fetch(`https://genesis-platforms-8157acd2d107.herokuapp.com/api/GenesisOpenAi_Landing_Pages_Content_Creating`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        prompt: searchKeyword
                    })
                })

                const dataChat = await resChat.json()

                setResponse(JSON.parse(dataChat.content))
            } catch (error) {
                console.log(error);
            }
            window.addEventListener('scroll', handleScroll, { passive: true });
            return () => {
                window.removeEventListener('scroll', handleScroll);
            };
        })()

    }, []);
    // Loading Call Rail Script
    useEffect(() => {
        const timer = setTimeout(() => {
            const script = document.createElement("script");
            script.type = "text/javascript";
            script.src = "//cdn.callrail.com/companies/296811663/597ec7d509fdfc114708/12/swap.js";
            script.async = true;
            document.head.appendChild(script);
        }, 750);

        return () => clearTimeout(timer); // cleanup on unmount
    }, []);

    const AllCompanies = <div className={ShowAllCompanies ? `CompaniesList2Hidden CompaniesList2` : "CompaniesList2"}>
        <div className="CompaniesList2HiddenFade" onClick={() => setShowAllCompanies(!ShowAllCompanies)}></div>
        <div className="CompaniesList2Header">
            {ShowAllCompanies ?
                <span className="CompaniesList2HiddenGoBacl" onClick={() => setShowAllCompanies(!ShowAllCompanies)}>
                    <img src={require(`../../Images/back.png`)} alt="" />
                    <h3>Get competitive quotes</h3>
                </span>
                : null}
            <h2><img src={require(`../../Images/3d-house.png`)} alt="" />Results for {CitiesData && CitiesData.City ? CitiesData.City : "Near You"}</h2>
            <h1>{DateServiceType ? DateServiceType.Category : ""} Companies | {CitiesData && CitiesData.Full ? CitiesData.Full : "Near You"}</h1>
        </div>
        <div className="CompaniesList2List">
            <div className="CompaniesList2ListGueatnee"  >
                <span>
                    <img src={require(`../../Images/verifed.png`)} />
                    <h1>HANDYBY GUARANTEE</h1>
                </span>
                <h3>Get It Done Right — Backed by HandyBy <b onClick={() => setShowMoreMobile(true)}>More Details</b></h3>
            </div>
            {Companies ? Companies.slice(0, 4).map((A, index) => {
                // BusinessUrl
                const BusinessUrlLocation = url.searchParams.get('area') + "/" + (CitiesData && CitiesData.Full ? CitiesData.Full.split(',').map(part => part.trim().replace(/\s+/g, '-')).join(',') : '');
                const BusinessUrl = DateServiceType && DateServiceType.UrlCategory == "Chimney-Fireplace" ? A.website_Chimney + BusinessUrlLocation : DateServiceType && DateServiceType.UrlCategory == "Air-Duct" ? A.website_AirDuct + BusinessUrlLocation : DateServiceType && DateServiceType.UrlCategory == "Dryer-Vent" ? A.website_Dryer + BusinessUrlLocation : "null";
                const BusinessUrlBook = DateServiceType && DateServiceType.UrlCategory == "Chimney-Fireplace" ? A.websiteBook + BusinessUrlLocation : DateServiceType && DateServiceType.UrlCategory == "Air-Duct" ? A.websiteBook + BusinessUrlLocation : DateServiceType && DateServiceType.UrlCategory == "Dryer-Vent" ? A.websiteBook + BusinessUrlLocation : "null";
                const UrlSearch = url.search ? url.search + `&cp=${A.phoneHandyBy}&handyby=yes` : `?cp=${A.phoneHandyBy}&handyby=yes`;

                const BHO_Chimney_Sweep_Book_URL = DateServiceType && DateServiceType.UrlCategory == "Chimney-Fireplace" ? `${BusinessUrlBook + UrlSearch}` : DateServiceType && DateServiceType.UrlCategory == "Air-Duct" ? `${BusinessUrlBook + UrlSearch + '&service=airduct'}` : DateServiceType && DateServiceType.UrlCategory == "Dryer-Vent" ? `${BusinessUrlBook + UrlSearch + '&service=airduct'}` : "null";
                const Master_Air_Duct_Book_URL = DateServiceType && DateServiceType.UrlCategory == "Chimney-Fireplace" ? `${BusinessUrlBook + UrlSearch + '&service=chimney'}` : DateServiceType && DateServiceType.UrlCategory == "Air-Duct" ? `${BusinessUrlBook + UrlSearch}` : DateServiceType && DateServiceType.UrlCategory == "Dryer-Vent" ? `${BusinessUrlBook + UrlSearch}` : "null";
                const Rocket_Air_Care_Book_URL = `${BusinessUrl + UrlSearch + '#book'}`;
                const Smith_And_Sons_Chimney_Book_URL = DateServiceType && DateServiceType.UrlCategory == "Chimney-Fireplace" ? `${BusinessUrlBook + UrlSearch}` : DateServiceType && DateServiceType.UrlCategory == "Air-Duct" ? `${BusinessUrlBook + UrlSearch + '&service=airduct'}` : DateServiceType && DateServiceType.UrlCategory == "Dryer-Vent" ? `${BusinessUrlBook + UrlSearch + '&service=dryer'}` : "null";

                // const randomIndex = Math.floor(Math.random() * 3) + 1;

                return (
                    <div className="CompaniesListBox" key={A.name + index}>
                        <div className="CompaniesListBoxTop">
                            <div className="CompaniesListBoxTopMain">
                                <div className="CompaniesListBoxTopLeft">
                                    <img src={A.images[0]} alt={A.name} />
                                </div>
                                <div className="CompaniesListBoxMiddle">
                                    {/* <a href={`/pro/${A.nameUrl + UrlSearch}`}>{A.name}</a> */}
                                    <a onClick={() => fireOpenAIEvent(A.name, "web_click")} href={`/pro/${A.nameUrl + UrlSearch}&finalUrl=${encodeURIComponent(BusinessUrl + UrlSearch)}&finalUrlBook=${encodeURIComponent(Companies[index].name == "BHO Chimney Sweep" ? BHO_Chimney_Sweep_Book_URL : Companies[index].name == "Rocket Air Care" ? Rocket_Air_Care_Book_URL : Companies[index].name == "Master Air Duct" ? Master_Air_Duct_Book_URL : Companies[index].name == "Smith and Sons Chimney" ? Smith_And_Sons_Chimney_Book_URL : "null")}`} target="_blank" ><img src={A.favicon} alt={`${A.name} Reviews`} /> {A.name}</a>

                                    <div className="CompaniesListBoxMiddleRating">
                                        <h2>
                                            {A.rating} &nbsp;
                                            <span>
                                                <img src={require(`../../Images/star.png`)} alt="" />
                                                <img src={require(`../../Images/star.png`)} alt="" />
                                                <img src={require(`../../Images/star.png`)} alt="" />
                                                <img src={require(`../../Images/star.png`)} alt="" />
                                                <img src={require(`../../Images/star.png`)} alt="" />
                                            </span>
                                            ({A.reviews.length})
                                        </h2>
                                        <h3>{DateServiceType ? DateServiceType.Category + " Companies" : ""}</h3>
                                    </div>
                                    <div className="CompaniesListBoxTopMainBenefits">
                                        <h2>{A.highlights[0].replace(" ", "+ ")} &nbsp;·&nbsp; Serves {CitiesData ? CitiesData.City : "Your Area"}</h2>
                                    </div>
                                    <div className="CompaniesListBoxTopMainBenefits">
                                        <h2><span>Open 24/7</span> &nbsp;·&nbsp; {A.highlights[(index + 1) - 1]}</h2>
                                    </div>
                                    <div className="CompaniesListBoxTopMainBenefits">
                                        <h2> <a onClick={() => fireOpenAIEvent(A.name, "phone_call")} href={`tel:${A.phoneHandyBy}`}>({A.phoneHandyBy}) </a> &nbsp;·&nbsp; <img src={require(`../../Images/verifed.png`)} alt="" /> GUARANTEE</h2>
                                    </div>
                                </div>

                            </div>

                            <div className="CompaniesListBoxTopRight">

                                <a onClick={() => fireOpenAIEvent(A.name, "phone_call")} href={`tel:${A.phoneHandyBy}`}>
                                    <span>
                                        <img src={require(`../../Images/telephone.png`)} alt="" />
                                    </span>
                                    <h4>Click to Call</h4>

                                </a>
                                <a onClick={() => fireOpenAIEvent(Companies[index].name, "web_click")} href={`${Companies[index].name == "BHO Chimney Sweep" ? BHO_Chimney_Sweep_Book_URL : Companies[index].name == "Rocket Air Care" ? Rocket_Air_Care_Book_URL : Companies[index].name == "Master Air Duct" ? Master_Air_Duct_Book_URL : Companies[index].name == "Smith and Sons Chimney" ? Smith_And_Sons_Chimney_Book_URL : "null"}`} target="_blank" >
                                    <span>
                                        <img src={require(`../../Images/book.png`)} alt="" />
                                    </span>
                                    <h4>Schedule Online</h4>
                                </a>

                            </div>
                        </div>
                    </div>)
            }) : <h1>Loading...</h1>}
        </div>
    </div>

    return (
        <div className="Companies">
            <Helmet>
                {/* <!-- TITLE --> */}
                <title>HandyBy - Top 5 Trusted {serviceParam.replace(/-/g, ' ').split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') ? serviceParam.replace(/-/g, ' ').split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') : "Service"} Pros Near You</title>

                {/* <!-- META --> */}
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="website" />
                <meta property="og:image" content="%PUBLIC_URL%/service-banner.jpg" />
                <meta property="og:url" content={`https://www.handyby.com/${serviceParam.replace(/-/g, ' ').split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') ? serviceParam.replace(/-/g, ' ').split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ').replace(/\s+/g, '-').toLowerCase() : "service"}`} />
                <meta name="description" content={`Get matched with a trusted local pro for affordable ${serviceParam.replace(/-/g, ' ').split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') ? serviceParam.replace(/-/g, ' ').split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') : "service"}. Enter your ZIP code to request service now—no commitment until you approve the price.`} />
                <meta property="og:title" content={`HandyBy - Top-Rated ${serviceParam.replace(/-/g, ' ').split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') ? serviceParam.replace(/-/g, ' ').split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') : "Service"} Pros`} />
                <meta property="og:description" content={`Fast, reliable ${serviceParam.replace(/-/g, ' ').split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') ? serviceParam.replace(/-/g, ' ').split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') : "service"} from verified pros in {CitiesData && CitiesData.Full ? CitiesData.Full : "Your Area"}. No upfront fees—book with confidence.`} />
                <meta property="og:site_name" content="HandyBy" />
                <meta name="keywords" content={`${serviceParam.replace(/-/g, ' ').split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') ? serviceParam.replace(/-/g, ' ').split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') + ", " : ""}Local Pros, HandyBy, Affordable Service`} />
                <link rel="canonical" href={`https://www.handyby.com/pros/${serviceParam}`} />
                <meta name="robots" content="index, follow, max-image-preview:large" />
                <script type="application/ld+json">{JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "ItemList",
                    "name": `Top Pros — ${serviceParam.replace(/-/g, ' ')}`,
                    "url": `https://www.handyby.com/pros/${serviceParam}`,
                    "itemListElement": (Companies || []).slice(0, 5).map((c, i) => ({
                        "@type": "ListItem",
                        "position": i + 1,
                        "name": c.name || c.nameUrl,
                        "url": `https://www.handyby.com/pro/${c.nameUrl}`
                    }))
                })}</script>
                <script type="application/ld+json">{JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "BreadcrumbList",
                    "itemListElement": [
                        { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://www.handyby.com/" },
                        { "@type": "ListItem", "position": 2, "name": "Pros", "item": `https://www.handyby.com/pros/${serviceParam}` }
                    ]
                })}</script>
            </Helmet>


            {/* CategoryNav */}
            <div className="CategoryNav">
                <div className="CategoryNavShape">
                    <span>
                        <h1>HandyBy /</h1>
                        <h1>Pro /</h1>
                        <h1>Top 5 {DateServiceType ? DateServiceType.Category + " Pros" : "Services"}</h1>
                    </span>
                </div>
            </div>

            {/* HomePageTopBanner */}
            <div className="HomePageTopBanner" >
                <img className="HomePageTopBannerImg" src={DateServiceType ? DateServiceType.Image : null} alt="Chimney Cleaning" />
                <div className="HomePageTopBannerText" >
                    <h1>Top 5 Best {DateServiceType ? DateServiceType.Category + " Pros" : "Pros"} in {CitiesData && CitiesData.Full ? CitiesData.Full : "Your Area"}</h1>
                    <h2>Choose from the Top 5 Rated {DateServiceType ? DateServiceType.Category + " Contractors" : "Contractors"} in {CitiesData && CitiesData.Full ? CitiesData.Full : "Your Area"}</h2>
                    <img src={require(`../../Images/TrustPilot.png`)} />
                </div>
            </div>

            {/* CompaniesTitle */}
            <div className="CompaniesTitle" id="CompaniesTitle">
                <h1>Top 5 {DateServiceType ? DateServiceType.Category + " Contractors" : "Contractors"}</h1>
                <h2>We’ve done the work for you — here are the Top 5 highest-rated {DateServiceType ? DateServiceType.Category + " professionals" : "professionals"} in {CitiesData && CitiesData.Full ? CitiesData.Full : "Your Area"}. Choose a trusted pro for fast, affordable, and reliable service.</h2>
                {typeof window !== "undefined" && window.innerWidth >= 800 && (

                    <div className="CompanyPageRightHandyByVerifed">
                        <span>
                            <img src={require(`../../Images/verifed.png`)} />
                            <h1>HANDYBY GUARANTEE</h1>
                        </span>

                        {/* Show More / Hide functionality only on max-width 800px */}
                        {(() => {
                            const fullText = `These are the Top 5 ${DateServiceType ? DateServiceType.Category + " Companies" : "Companies"} in ${CitiesData && CitiesData.Full ? CitiesData.Full : "Your Area"}, carefully selected by HandyBy based on strict quality criteria.
                        Our team evaluates each provider on key factors such as customer reviews, service reliability, safety standards, response time, and overall satisfaction.
                        We only feature companies that meet our high standards — so you can feel confident choosing any of the professionals listed here.`;
                            const halfLength = Math.floor(fullText.length / 2 + 10);
                            const shortText = fullText.slice(0, halfLength) + "...";

                            // Check if window is defined and screen width is <= 800px
                            const isMobile = typeof window !== "undefined" && window.innerWidth <= 800;

                            if (isMobile) {
                                return (
                                    <h2>
                                        {showMore ? fullText : shortText} <span onClick={() => setShowMore(!showMore)}>{showMore ? "Hide" : "Show More"}</span>
                                    </h2>
                                );
                            } else {
                                return <h2>{fullText}</h2>;
                            }
                        })()}
                    </div>
                )}

            </div>

            {/* CompaniesList */}
            <div className="CompaniesList" id="CompaniesList">
                {Companies ? Companies.slice(0, 4).map((A, index) => {
                    // BusinessUrl
                    const BusinessUrlLocation = url.searchParams.get('area') + "/" + (CitiesData && CitiesData.Full ? CitiesData.Full.split(',').map(part => part.trim().replace(/\s+/g, '-')).join(',') : '');
                    const BusinessUrl = DateServiceType && DateServiceType.UrlCategory == "Chimney-Fireplace" ? A.website_Chimney + BusinessUrlLocation : DateServiceType && DateServiceType.UrlCategory == "Air-Duct" ? A.website_AirDuct + BusinessUrlLocation : DateServiceType && DateServiceType.UrlCategory == "Dryer-Vent" ? A.website_Dryer + BusinessUrlLocation : "null";
                    const BusinessUrlBook = DateServiceType && DateServiceType.UrlCategory == "Chimney-Fireplace" ? A.websiteBook + BusinessUrlLocation : DateServiceType && DateServiceType.UrlCategory == "Air-Duct" ? A.websiteBook + BusinessUrlLocation : DateServiceType && DateServiceType.UrlCategory == "Dryer-Vent" ? A.websiteBook + BusinessUrlLocation : "null";
                    const UrlSearch = url.search ? url.search + `&cp=${A.phoneHandyBy}&handyby=yes` : `?cp=${A.phoneHandyBy}&handyby=yes`;

                    const BHO_Chimney_Sweep_Book_URL = DateServiceType && DateServiceType.UrlCategory == "Chimney-Fireplace" ? `${BusinessUrlBook + UrlSearch}` : DateServiceType && DateServiceType.UrlCategory == "Air-Duct" ? `${BusinessUrlBook + UrlSearch + '&service=airduct'}` : DateServiceType && DateServiceType.UrlCategory == "Dryer-Vent" ? `${BusinessUrlBook + UrlSearch + '&service=airduct'}` : "null";
                    const Master_Air_Duct_Book_URL = DateServiceType && DateServiceType.UrlCategory == "Chimney-Fireplace" ? `${BusinessUrlBook + UrlSearch + '&service=chimney'}` : DateServiceType && DateServiceType.UrlCategory == "Air-Duct" ? `${BusinessUrlBook + UrlSearch}` : DateServiceType && DateServiceType.UrlCategory == "Dryer-Vent" ? `${BusinessUrlBook + UrlSearch}` : "null";
                    const Rocket_Air_Care_Book_URL = `${BusinessUrl + UrlSearch + '#book'}`;
                    const Smith_And_Sons_Chimney_Book_URL = DateServiceType && DateServiceType.UrlCategory == "Chimney-Fireplace" ? `${BusinessUrlBook + UrlSearch}` : DateServiceType && DateServiceType.UrlCategory == "Air-Duct" ? `${BusinessUrlBook + UrlSearch + '&service=airduct'}` : DateServiceType && DateServiceType.UrlCategory == "Dryer-Vent" ? `${BusinessUrlBook + UrlSearch + '&service=dryer'}` : "null";
                    return (
                        <div className="CompaniesListBox" key={A.name + index}>
                            {index === 0 ?
                                <div className="CompaniesListBoxRating">
                                    <img src={require(`../../Images/ranking.png`)} alt="" />
                                    <h2>People's Choice</h2>
                                </div>
                                :
                                <div className="CompaniesListBoxRatingGreen">
                                    <img src={require(`../../Images/high-quality.png`)} alt="" />
                                    <h2>Highly Rated</h2>
                                </div>
                            }
                            <div className="CompaniesListBoxTop">
                                <div className="CompaniesListBoxTopMain">
                                    <div className="CompaniesListBoxTopLeft">
                                        <img src={A.imgLogo} alt={A.name} />
                                    </div>
                                    <div className="CompaniesListBoxMiddle">
                                        <a onClick={() => fireOpenAIEvent(A.name, "web_click")} href={`/pro/${A.nameUrl + UrlSearch}&finalUrl=${encodeURIComponent(BusinessUrl + UrlSearch)}&finalUrlBook=${encodeURIComponent(Companies[index].name == "BHO Chimney Sweep" ? BHO_Chimney_Sweep_Book_URL : Companies[index].name == "Rocket Air Care" ? Rocket_Air_Care_Book_URL : Companies[index].name == "Master Air Duct" ? Master_Air_Duct_Book_URL : Companies[index].name == "Smith and Sons Chimney" ? Smith_And_Sons_Chimney_Book_URL : "null")}`} target="_blank" ><img src={A.favicon} alt={`${A.name} Reviews`} /> {A.name}</a>
                                        <h2>
                                            <b>{A.rating} &nbsp;</b>
                                            <img src={require(`../../Images/star.png`)} alt={`${A.name} Reviews`} />
                                            <img src={require(`../../Images/star.png`)} alt={`${A.name} Reviews`} />
                                            <img src={require(`../../Images/star.png`)} alt={`${A.name} Reviews`} />
                                            <img src={require(`../../Images/star.png`)} alt={`${A.name} Reviews`} />
                                            <img src={require(`../../Images/star.png`)} alt={`${A.name} Reviews`} />
                                            ({A.reviews.length}) • &nbsp; <img src={require(`../../Images/verifed.png`)} alt="" />
                                            {/* Text */}
                                            GUARANTEE
                                        </h2>
                                        <h3><img src={require(`../../Images/heart.png`)} alt="" />Times Hired on HandyBy: <b>&nbsp; {A.reviews.length * 3}</b></h3>
                                        <h3><img src={require(`../../Images/heart.png`)} alt="" />Customer say: <b>&nbsp; Quick response</b></h3>
                                        <h3><img src={require(`../../Images/heart.png`)} alt="" />Recommended by <b>&nbsp; 100% &nbsp;</b></h3>
                                        <h3><img src={require(`../../Images/experience.png`)} alt="" /><b>{A.highlights[0]}</b></h3>
                                    </div>
                                </div>

                                <div className="CompaniesListBoxTopRight">
                                    <div className="CompaniesListBoxTopRightRating">
                                        <h1>{index === 0 ? "9.9" : "9.6"}</h1>
                                        <span>
                                            <h2>{index === 0 ? "EXCELLENT" : "VERY GOOD"}</h2>
                                            <span>
                                                <img src={require(`../../Images/star.png`)} alt="" />
                                                <img src={require(`../../Images/star.png`)} alt="" />
                                                <img src={require(`../../Images/star.png`)} alt="" />
                                                <img src={require(`../../Images/star.png`)} alt="" />
                                                <img src={require(`../../Images/star.png`)} alt="" />
                                            </span>
                                        </span>
                                    </div>
                                    <h3>{index === 0 ? "Top Rated. Trusted by HandyBy." : "Reviewed. Rated. Recommended by HandyBy."}</h3>
                                </div>
                            </div>
                            <div className="CompaniesListBoxBottom">
                                <h2>{DateServiceType && DateServiceType.UrlCategory == "Chimney-Fireplace" ? A.Chimney_Review : DateServiceType && DateServiceType.UrlCategory == "Air-Duct" ? A.AirDuct_Review : DateServiceType && DateServiceType.UrlCategory == "Dryer-Vent" ? A.Dryer_Review : "null"}</h2>
                            </div>
                            <div className="CompaniesListBoxBoook">
                                <span className="CompaniesListBoxBoookLeft">
                                    <h2>You can request a quote from this business</h2>
                                    <h3>{A.reviews.length - 18} locals recently requested a quote</h3>
                                </span>
                                <span className="CompaniesListBoxBoookRight">
                                    <a onClick={() => fireOpenAIEvent(A.name, "phone_call")} href={`tel:${A.phoneHandyBy}`}>Click to Call ({A.phoneHandyBy}) </a>
                                    <a onClick={() => fireOpenAIEvent(A.name, "web_click")} href={BusinessUrl + UrlSearch} target="_blank" >Visit Website</a>
                                    <a onClick={() => fireOpenAIEvent(Companies[index].name, "web_click")} href={`${Companies[index].name == "BHO Chimney Sweep" ? BHO_Chimney_Sweep_Book_URL : Companies[index].name == "Rocket Air Care" ? Rocket_Air_Care_Book_URL : Companies[index].name == "Master Air Duct" ? Master_Air_Duct_Book_URL : Companies[index].name == "Smith and Sons Chimney" ? Smith_And_Sons_Chimney_Book_URL : "null"}`} target="_blank" >SCHEDULE ONLINE <img src={require(`../../Images/book.png`)} alt="" /></a>
                                </span>
                            </div>
                        </div>)
                }) : <h1>Loading...</h1>}

            </div>

            {/* CategoryAI */}
            <div className="CategoryAI">
                <img src={require(`../../Images/ai-technology.png`)} />
                <div className="CategoryAIText">
                    <h4>{response.title}</h4>
                    <h3>{response.body}</h3>
                </div>
            </div>

            {/* ServicesOurTop3Offers */}
            <div className="ServicesTop3Offer" id="Services">
                <h2>Our Top 5 Contractors {DateServiceType && DateServiceType.Services ? DateServiceType.Category : ""} Services</h2>
                <h3>These are our Top 5 {DateServiceType && DateServiceType.Services ? DateServiceType.Category : ""} Contractors and the services they offer—trusted experts chosen for their quality, reliability, and outstanding customer satisfaction.</h3>
                <div className="ServicesTop3OfferList" ref={containerRefscrollRightOffer}>
                    {DateServiceType && DateServiceType.Services ? DateServiceType.Services.map((A, index) => (
                        <div className="ServicesTop3OfferBox" key={index}>
                            <img src={A.Images} alt={A.Title} />
                            <h1>{A.Title}</h1>
                            <h2>{A.Description}</h2>
                        </div>
                    )) : <h1>Loading...</h1>}
                </div>
                <div className="HomePageOfferSCrollRight" onClick={scrollRightOffer}>
                    <img src={require(`../../Images/next.png`)} />
                </div>
            </div>

            {/* CompaniesList2 */}
            {AllCompanies}

            {/* CategoryReviews */}
            <div className="CategoryReviews" id="CategoryReviews">
                <div className="CategoryReviewsTitle">
                    <h1>Verified Reviews for <span>{DateServiceType ? DateServiceType.Category : ""}</span> pros <span>{CitiesData && CitiesData.Full ? "in " + CitiesData.Full : "Near You"}</span></h1>
                    <h2>The HandyBy Rating For {DateServiceType ? DateServiceType.Category : ""} Pros {CitiesData && CitiesData.City ? "in " + CitiesData.City : "Near You"} Is Based On Verified Reviews From Homeowners Who Have Hired These Pros For Their {DateServiceType ? DateServiceType.Category : ""} Project And Repair Needs.</h2>
                </div>
                <div className="CategoryReviewsList" ref={containerRefReviews}>
                    {DateServiceType ? DateServiceType.Reviews.map((A, Index) => {
                        return <div key={Index} className="CategoryReviewsListBox">
                            <div className="CategoryReviewsListBoxTop">
                                <h1>{A.name}</h1>
                                <span>
                                    <img src={require(`../../Images/star.png`)} />
                                    <img src={require(`../../Images/star.png`)} />
                                    <img src={require(`../../Images/star.png`)} />
                                    <img src={require(`../../Images/star.png`)} />
                                    <img src={require(`../../Images/star.png`)} />
                                </span>
                                <h2>Reviewed in {A.date}</h2>
                                <h3>{A.review.slice(0, 165) + '...'}</h3>
                            </div>
                        </div>
                    }) : <h1>Loading...</h1>}
                </div>
                <div className="HomePageServicesListSCrollRight" onClick={scrollRightReviews}>
                    <img src={require(`../../Images/next.png`)} />
                </div>
                <div className="CategoryReviewsConfirmed">
                    <img src={require(`../../Images/n-success.png`)} />
                    <h2>Companies on HandyBy can’t offer incentives or pay to hide any reviews.</h2>
                </div>
            </div>

            {/* CategoryByServices */}
            <div className="CategoryByServices">
                <h2>Top 5 Professional {DateServiceType?.Category} Services</h2>
                <h3>These top-rated contractors specialize in {DateServiceType?.Category}—handpicked for their expertise, customer satisfaction, and service quality. Explore the key services they offer below.</h3>

                <div className="CategoryByServicesList" ref={containerRefscrollRightKeyWords}>
                    {DateServiceType && DateServiceType.ServicesByCategory ? DateServiceType.ServicesByCategory.map((A, index) => (
                        <div className="CategoryByServicesListItem" key={index}>
                            <h4><img src={require('../../Images/technician.png')} alt="" />{A.category}</h4>
                            <div className="CategoryByServicesListItemKeyWords">

                                {A.services.map((keyword, keywordIndex) => {
                                    const capitalized = keyword.charAt(0).toUpperCase() + keyword.slice(1);
                                    return <h5 key={keywordIndex} >• {capitalized}</h5>;
                                })}
                            </div>
                        </div>
                    )) : null}

                </div>
                <div className="HomePageServicesListSCrollRight" onClick={scrollRightKeyWords}>
                    <img src={require(`../../Images/next.png`)} />
                </div>
            </div>

            {/* CompaniesList3 */}
            <div className="CompaniesList3">
                <div className="CompaniesList2HiddenFade" onClick={() => setShowAllCompanies(!ShowAllCompanies)}></div>
                <div className="CompaniesList2Header">
                    {ShowAllCompanies ?
                        <span className="CompaniesList2HiddenGoBacl" onClick={() => setShowAllCompanies(!ShowAllCompanies)}>
                            <img src={require(`../../Images/back.png`)} alt="" />
                            <h3>Get competitive quotes</h3>
                        </span>
                        : null}
                    <h2><img src={require(`../../Images/3d-house.png`)} alt="" />Results for {CitiesData && CitiesData.City ? CitiesData.City : "Near You"}</h2>
                    <h1>{DateServiceType ? DateServiceType.Category : ""} Companies | {CitiesData && CitiesData.Full ? CitiesData.Full : "Near You"}</h1>
                </div>
                <div className="CompaniesList2List">

                    {Companies ? Companies.slice(0, 4).map((A, index) => {
                        const BusinessUrlLocation = url.searchParams.get('area') + "/" + (CitiesData && CitiesData.Full ? CitiesData.Full.split(',').map(part => part.trim().replace(/\s+/g, '-')).join(',') : '');
                        const BusinessUrl = DateServiceType && DateServiceType.UrlCategory == "Chimney-Fireplace" ? A.website_Chimney + BusinessUrlLocation : DateServiceType && DateServiceType.UrlCategory == "Air-Duct" ? A.website_AirDuct + BusinessUrlLocation : DateServiceType && DateServiceType.UrlCategory == "Dryer-Vent" ? A.website_Dryer + BusinessUrlLocation : "null";
                        const BusinessUrlBook = DateServiceType && DateServiceType.UrlCategory == "Chimney-Fireplace" ? A.websiteBook + BusinessUrlLocation : DateServiceType && DateServiceType.UrlCategory == "Air-Duct" ? A.websiteBook + BusinessUrlLocation : DateServiceType && DateServiceType.UrlCategory == "Dryer-Vent" ? A.websiteBook + BusinessUrlLocation : "null";
                        const UrlSearch = url.search ? url.search + `&cp=${A.phoneHandyBy}&handyby=yes` : `?cp=${A.phoneHandyBy}&handyby=yes`;

                        const BHO_Chimney_Sweep_Book_URL = DateServiceType && DateServiceType.UrlCategory == "Chimney-Fireplace" ? `${BusinessUrlBook + UrlSearch}` : DateServiceType && DateServiceType.UrlCategory == "Air-Duct" ? `${BusinessUrlBook + UrlSearch + '&service=airduct'}` : DateServiceType && DateServiceType.UrlCategory == "Dryer-Vent" ? `${BusinessUrlBook + UrlSearch + '&service=airduct'}` : "null";
                        const Master_Air_Duct_Book_URL = DateServiceType && DateServiceType.UrlCategory == "Chimney-Fireplace" ? `${BusinessUrlBook + UrlSearch + '&service=chimney'}` : DateServiceType && DateServiceType.UrlCategory == "Air-Duct" ? `${BusinessUrlBook + UrlSearch}` : DateServiceType && DateServiceType.UrlCategory == "Dryer-Vent" ? `${BusinessUrlBook + UrlSearch}` : "null";
                        const Rocket_Air_Care_Book_URL = `${BusinessUrl + UrlSearch + '#book'}`;
                        const Smith_And_Sons_Chimney_Book_URL = DateServiceType && DateServiceType.UrlCategory == "Chimney-Fireplace" ? `${BusinessUrlBook + UrlSearch}` : DateServiceType && DateServiceType.UrlCategory == "Air-Duct" ? `${BusinessUrlBook + UrlSearch + '&service=airduct'}` : DateServiceType && DateServiceType.UrlCategory == "Dryer-Vent" ? `${BusinessUrlBook + UrlSearch + '&service=dryer'}` : "null";

                        return (
                            <div className="CompaniesListBox" key={A.name + index}>
                                <div className="CompaniesListBoxTop">
                                    <div className="CompaniesListBoxTopMain">
                                        <div className="CompaniesListBoxTopLeft">
                                            <img src={A.imgLogo} alt={A.name} />
                                        </div>
                                        <div className="CompaniesListBoxMiddle">
                                            <a onClick={() => fireOpenAIEvent(A.name, "web_click")} href={`/pro/${A.nameUrl + UrlSearch}&finalUrl=${encodeURIComponent(BusinessUrl + UrlSearch)}&finalUrlBook=${encodeURIComponent(Companies[index].name == "BHO Chimney Sweep" ? BHO_Chimney_Sweep_Book_URL : Companies[index].name == "Rocket Air Care" ? Rocket_Air_Care_Book_URL : Companies[index].name == "Master Air Duct" ? Master_Air_Duct_Book_URL : Companies[index].name == "Smith and Sons Chimney" ? Smith_And_Sons_Chimney_Book_URL : "null")}`} target="_blank" > {A.name}</a>
                                            <div className="CompaniesListBoxMiddleRating">
                                                <h2>
                                                    {A.rating} &nbsp;
                                                    <span>
                                                        <img src={require(`../../Images/star.png`)} alt="" />
                                                        <img src={require(`../../Images/star.png`)} alt="" />
                                                        <img src={require(`../../Images/star.png`)} alt="" />
                                                        <img src={require(`../../Images/star.png`)} alt="" />
                                                        <img src={require(`../../Images/star.png`)} alt="" />
                                                    </span>
                                                    ({A.reviews.length})
                                                </h2>
                                                <h3>{DateServiceType ? DateServiceType.Category + " Companies" : ""}</h3>
                                            </div>
                                            <div className="CompaniesListBoxTopMainBenefits">
                                                <h2> <a onClick={() => fireOpenAIEvent(A.name, "phone_call")} href={`tel:${A.phoneHandyBy}`}>({A.phoneHandyBy}) </a> &nbsp;·&nbsp; <img src={require(`../../Images/verifed.png`)} alt="" /> HANDYBY GUARANTEE</h2>
                                            </div>
                                        </div>

                                    </div>

                                    <div className="CompaniesListBoxTopRight">

                                        <a onClick={() => fireOpenAIEvent(A.name, "phone_call")} href={`tel:${A.phoneHandyBy}`}>
                                            <span>
                                                <img src={require(`../../Images/telephone.png`)} alt="" />
                                            </span>
                                            <h4>Click to Call</h4>

                                        </a>
                                        <a onClick={() => fireOpenAIEvent(Companies[index].name, "web_click")} href={`${Companies[index].name == "BHO Chimney Sweep" ? BHO_Chimney_Sweep_Book_URL : Companies[index].name == "Rocket Air Care" ? Rocket_Air_Care_Book_URL : Companies[index].name == "Master Air Duct" ? Master_Air_Duct_Book_URL : Companies[index].name == "Smith and Sons Chimney" ? Smith_And_Sons_Chimney_Book_URL : "null"}`} target="_blank" >
                                            <span>
                                                <img src={require(`../../Images/book.png`)} alt="" />
                                            </span>
                                            <h4>Schedule Online</h4>
                                        </a>

                                    </div>
                                </div>
                            </div>)
                    }) : <h1>Loading...</h1>}
                </div>
            </div>

            {/* CategoryFaq */}
            <div className="CategoryFaq" id="CategoryFaq">
                <h1>{DateServiceType ? DateServiceType.Category : "Services"} questions, answered by experts</h1>
                <div className="MainBanner4FaqMore">
                    {DateServiceType && DateServiceType.faq ?
                        <Faq
                            data={DateServiceType.faq.data}
                            styles={DateServiceType.faq.styles}
                            config={DateServiceType.faq.config}
                        />
                        : <h1>Loading...</h1>}
                </div>
            </div>


            {/* Tools */}
            {/* ShowAllCompanies */}
            {ShowAllCompanies ? React.cloneElement(AllCompanies, { className: `${AllCompanies.props.className} AllCompaniesUnique` }) : null}
            {/* CompaniesHandyBYVerified */}
            {typeof window !== "undefined" && window.innerWidth <= 800 && (
                <div className="CompaniesHandyBYVerified" style={showMoreMobile ? { zIndex: "999" } : { zIndex: "5" }} onMouseLeave={() => setShowMoreMobile(false)}>

                    <div className="CompanyPageRightHandyByVerifed" onClick={() => setShowMoreMobile(!showMoreMobile)}>
                        <span>
                            <img src={require(`../../Images/verifed.png`)} />
                            <h1>HANDYBY GUARANTEE</h1>
                        </span>
                        <span>
                            <h2>More Details</h2>
                            <img
                                style={{
                                    transform: showMoreMobile ? "rotate(180deg)" : "rotate(0deg)",
                                    transition: "transform 0.3s ease"
                                }}
                                src={require(`../../Images/ArrowDown.png`)}
                            />
                        </span>
                    </div>
                    <div
                        className={`CompaniesHandyBYVerifiedContent${showMoreMobile ? " open" : ""}`}
                        style={{
                            maxHeight: showMoreMobile ? "500px" : "0px",
                            overflow: "hidden",
                            transition: showMoreMobile
                                ? "max-height 0.5s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s ease"
                                : "max-height 0.5s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s ease",
                            opacity: showMoreMobile ? 1 : 0
                        }}
                    >
                        <div className="CompaniesHandyBYVerifiedContentBottom">
                            <span>
                                <h1>Badges of Confidenc</h1>
                            </span>
                            <h2>Some professionals on HandyBy display special badges that highlight verified credentials, background checks, and a strong track record of customer satisfaction. These badges are your assurance that you're choosing a trusted and qualified expert for the job.</h2>
                            <span>
                                <h1>HANDYBY GUARANTEE</h1>
                            </span>
                            <h2>
                                These are the Top 5 {DateServiceType ? DateServiceType.Category + " Companies" : "Companies"} in {CitiesData && CitiesData.Full ? CitiesData.Full : "Your Area"}, carefully selected by HandyBy based on strict quality criteria.
                                Our team evaluates each provider on key factors such as customer reviews, service reliability, safety standards, response time, and overall satisfaction.
                                We only feature companies that meet our high standards — so you can feel confident choosing any of the professionals listed here.
                            </h2>
                        </div>
                    </div>
                </div>
            )}
            {/* CompaniesMenu */}
            <div
                className={`CompaniesMenu CompaniesMenuButton${scrollButton ? " animate" : ""}`}
                onMouseLeave={() => setShowMenuMobile(false)}
                style={{
                    opacity: scrollButton ? 1 : 0,
                    transform: scrollButton ? "translateY(0)" : "translateY(-40px)",
                    transition: "opacity 0.5s ease, transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)"
                }} >
                <div className="CompaniesMenuRight">
                    <span onClick={() => setShowMenuMobile(!showMenuMobile)}>
                        <h1>Top 5 {DateServiceType ? DateServiceType.Category + " Pros" : "Services"}</h1>
                        <img
                            style={{
                                transform: showMenuMobile ? "rotate(180deg)" : "rotate(0deg)",
                                transition: "transform 0.3s ease"
                            }}
                            src={require(`../../Images/ArrowDown.png`)}
                        />
                    </span>
                    <button onClick={() => setShowAllCompanies(!ShowAllCompanies)}>Schedule Service</button>
                </div>
                <div className={`CompaniesMenuContent${showMenuMobile ? " open" : ""} CompaniesMenuContent`}
                    style={{
                        maxHeight: showMenuMobile ? "500px" : "0px",
                        overflow: "hidden",
                        transition: showMenuMobile
                            ? "max-height 0.5s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s ease"
                            : "max-height 0.5s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s ease",
                        opacity: showMenuMobile ? 1 : 0
                    }}
                >
                    <h3></h3>
                    <a onClick={() => { setShowMenuMobile(false); }} href="#CompaniesTitle">Top Rated Pros</a>
                    <a onClick={() => { setShowMenuMobile(false); }} href="#Services">Services</a>
                    <a onClick={() => { setShowMenuMobile(false); }} href="#CategoryReviews">Recent Reviews</a>
                    <a onClick={() => { setShowMenuMobile(false); }} href="#CategoryFaq">Faq</a>
                </div>
            </div>
            {/* GetFund Button */}
            <div className={`StartMatchingButton${scrollButtonFindPro ? " animate" : ""}`}
                style={{
                    opacity: scrollButtonFindPro ? 1 : 0,
                    transform: scrollButtonFindPro ? "translateY(0)" : "translateY(40px)",
                    transition: "opacity 0.5s ease, transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)"
                }}
            >
                <div onClick={() => setShowAllCompanies(!ShowAllCompanies)}>
                    <a className="ButtonStartMatchingButton" >Get Quote Now</a>
                    <h2>Find A Pro For Your {DateServiceType ? DateServiceType.Category : ""} Project.</h2>
                </div>

            </div>

            <NavigatorPath />
        </div >
    )
}

